<div class="modal-header pt-4 px-4">
  <h5 class="text-info">Logout Account</h5>
  <button type="button" class="close btn-close" (click)="activeModal.close()"></button>
</div>
<div class="modal-body main-modal px-4">
  <div>
    Are you sure, do you want to logout? Once you logout you need to login
    again. Are you okay?
  </div>
</div>

<div class="modal-footer pb-4 px-4">
  <a class="btn-outline-success btn me-3" (click)="activeModal.close()">Cancel</a>
  <a class="btn btn-success" (click)="logout()">Yes, Logout</a>
</div>